import { useParams } from 'react-router-dom';
import { assertIsDefined } from './assert-type';

export function useRequiredParam(paramName: string): string {
  const params = useParams();
  const result = params[paramName];
  assertIsDefined(result);
  return result;
}
